"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContainer = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const modal_layer_1 = require("./modal-layer");
const is_browser_1 = __importDefault(require("is-browser"));
const StyledChildrenContainer = components_core_1.styled.div `
  width: 100%;
  height: 100%;
`;
const getDefaultContent = () => {
    const DefaultContainer = components_core_1.styled.div `
    height: 80vh;
    color: ${props => props.theme.colors.content.secondary};
    background: lightgray
    width: cal(${props => props.theme.size.dynamic0050} + 24px);
    display: flex;
    align-items: center;
    justify-content: center;
  `;
    return (react_1.default.createElement(DefaultContainer, null,
        react_1.default.createElement("h1", null, "Modal Content")));
};
const ModalContainer = (props) => {
    const ModalLayerWithFocusLock = (0, components_core_1.withFocusLock)(modal_layer_1.ModalLayer);
    const [internalActive, setInternalActive] = react_1.default.useState(props.active);
    react_1.default.useEffect(() => {
        if (is_browser_1.default) {
            if (internalActive) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = 'unset';
            }
        }
        return () => {
            if (is_browser_1.default) {
                document.body.style.overflow = 'unset';
            }
        };
    }, [internalActive]);
    return (react_1.default.createElement(components_core_1.LayerWrapper, { contentCentered: true }, props.active
        ? [
            react_1.default.createElement(components_core_1.ShimLayer, { key: "shim" }),
            react_1.default.createElement(ModalLayerWithFocusLock, { key: "Modal-layer", active: props.active, ariaLabelledBy: props.ariaLabelledBy, onEscKeyUp: props.onCloseHandler, onCloseHandler: () => {
                    props.onCloseHandler(), setInternalActive(false);
                }, hideCloseIcon: props.hideCloseButton, scrollRef: props.scrollRef, ariaLabel: props.ariaLabel, closeButtonAriaLabel: props.closeButtonAriaLabel },
                react_1.default.createElement(components_core_1.Layout, { appearance: {
                        [components_core_1.Breakpoints.default]: [{ name: 'a', columns: 24 }]
                    } },
                    react_1.default.createElement(StyledChildrenContainer, null, props.children ? props.children : getDefaultContent()),
                    react_1.default.createElement(components_core_1.Container, { verticalAlign: "center", horizontalAlign: "center" })))
        ]
        : undefined));
};
exports.ModalContainer = ModalContainer;
